import React from "react";
import Scenes from "./Scenes";
import { useEffect, useContext } from "react";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/MyContext";
//file updated

export const TemplatesWrapper = ({}) => {
  const { authenticationData } = useContext(AuthContext);

  const { ScenesFolder, setScenesFolder } = useContext(MyContext);

  useEffect(() => {
    if (ScenesFolder.length <= 2) {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL + "/api/Scenes/GetScenesCategories",
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.categories) {
            let arr = [];
            for (let i = 0; i < response.data.categories.length; i++) {
              let obj = {
                id: 0,
                categoryName: "",
                defaultImgPath: "",
                data: [],
              };
              obj.id = response.data.categories[i].id;
              obj.categoryName = response.data.categories[i].categoryName;
              obj.defaultImgPath = response.data.categories[i].defaultImgPath;
              obj.data = [];
              arr.push(obj);
            }
            setScenesFolder(ScenesFolder.concat(arr));
          }
        })
        .catch((err) => {});
    }
  }, []);

  return (
    <>
      <div className="divLabel mb-3">Scenes</div>
      <div className="assetsScrol style-1">
        {ScenesFolder.map((lmc) => (
          <Scenes
            key={lmc.id}
            lmc={lmc}
            setScenesFolder={setScenesFolder}
            ScenesFolder={ScenesFolder}
          />
        ))}
      </div>
    </>
  );
};
export default TemplatesWrapper;
